export default __webpack_public_path__ + "static/media/php.01952c06.svg";